import register from '../register';
import PlacesAutoComplete from './classes/places-autocomplete';

register( 'check-availability', function() {
  const components = document.querySelectorAll('.check-availability-component');

  components.forEach( component => {
    const input     = component.querySelector('#check-availability-input');
    const list      = component.querySelector('.results');
    new PlacesAutoComplete({ input, list });
  });

});

export default undefined;
